import router from './router'
import store from './store'
import { ElMessage } from 'element-plus'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import localCache from '@/utils/cache'
import { RouteRecordRaw } from 'vue-router'

// 获取第一个可访问的路由
function getFirstAccessibleRoute(routes: RouteRecordRaw[]): string | null {
  for (const route of routes) {
    // 跳过隐藏的路由和根路径
    if (route.meta?.hidden || route.path === '/' || route.path === '/main') {
      continue
    }
    
    // 如果有子路由，递归查找第一个可访问的子路由
    if (route.children && route.children.length > 0) {
      const childRoute = getFirstAccessibleRoute(route.children)
      if (childRoute) {
        // 如果父路由有路径，需要拼接
        if (route.path && route.path !== '/') {
          return route.path + '/' + childRoute.replace(/^\//, '')
        }
        return childRoute
      }
    } else {
      // 没有子路由，返回当前路由路径
      return route.path
    }
  }
  return null
}

NProgress.configure({ showSpinner: false })

const whiteList: string[] = ['/login']

// 判断是否为外部链接
const isExternalLink = (path: string): boolean => {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 防止重定向循环的计数器
let redirectCount = 0
const MAX_REDIRECTS = 5

router.beforeEach((to, from, next) => {
  console.log('路由守卫 - 目标路径:', to.path, '来源路径:', from.path, '完整路径:', to.fullPath)

  // 检查重定向次数，防止无限循环
  if (redirectCount > MAX_REDIRECTS) {
    console.error('重定向次数过多，可能存在循环重定向')
    redirectCount = 0
    next('/main')
    NProgress.done()
    return
  }

  NProgress.start()
  
  // 检查是否为外部链接
  if (isExternalLink(to.path)) {
    // 打开外部链接
    window.open(to.path, '_blank')
    NProgress.done()
    return next(false)
  }
  
  // 检查token - 同时检查localStorage和store中的token
  const localStorageToken = localCache.getCache('token')
  const storeToken = store.state.token
  const token = localStorageToken || storeToken
  
  console.log('Token检查 - localStorage:', localStorageToken, 'store:', storeToken, '最终token:', token)
  
  if (token) {
    if (to.meta && to.meta.title) {
      store.dispatch('settings/setTitle', to.meta.title)
    }
    /* has token*/
    if (to.path === '/login') {
      redirectCount = 0 // 重置计数器
      next({ path: '/' })
      NProgress.done()
    } else if (whiteList.indexOf(to.path) !== -1) {
      redirectCount = 0 // 重置计数器
      next()
    } else {
      if (store.state.roles.length === 0) {
        console.log('store.state.roles',store.state.roles)
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(() => {
          store.dispatch('permission/GenerateRoutes').then((accessRoutes: RouteRecordRaw[]) => {
            console.log('accessRoutes',accessRoutes)
            // 如果是访问根路径或主页，跳转到第一个可访问的路由
            if (to.path === '/' || to.path === '/main') {
              const firstRoute = getFirstAccessibleRoute(accessRoutes)
              if (firstRoute && firstRoute !== '/' && firstRoute !== '/main') {
                console.log('跳转到第一个可访问路由:', firstRoute)
                redirectCount++
                next({ path: firstRoute, replace: true })
              } else {
                // 如果没有找到合适的路由，直接进入主页
                console.log('没有找到合适的路由，进入主页')
                redirectCount++
                next({ path: '/main', replace: true })
              }
            } else {
              console.log('路由重新匹配 - 目标路径:', to.path, '完整路径:', to.fullPath)
              redirectCount = 0 // 重置计数器
              next({ ...to, replace: true }) // hack方法 确保addRoute已完成
            }
          })
        }).catch((err: any) => {
          console.log('err',err)
          store.dispatch('user/LogOut').then(() => {
            ElMessage.error(err.msg)
            next({ path: '/login' })
          })
        })
      } else {
        // 如果已经有角色信息，但访问的是根路径或主页，也需要跳转到第一个可访问的路由
        if (to.path === '/' || to.path === '/main') {
          const sidebarRouters = (store.state as any).permission?.sidebarRouters || []
          const firstRoute = getFirstAccessibleRoute(sidebarRouters)
          if (firstRoute && firstRoute !== '/' && firstRoute !== '/main') {
            console.log('已有角色信息，跳转到第一个可访问路由:', firstRoute)
            redirectCount++
            next({ path: firstRoute, replace: true })
          } else {
            // 如果没有找到合适的路由，直接进入主页
            console.log('已有角色信息，但没有找到合适的路由，进入主页')
            redirectCount++
            next({ path: '/main', replace: true })
          }
        } else {
          redirectCount = 0 // 重置计数器
          next()
        }
      }
    }
  } else {
    console.log('没有token')
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach((to) => {
  console.log('to',to)
  NProgress.done()
})